import {Link} from "react-router-dom"

export default function ServicesDropdown({onNavigate}){
 return(
  <li className="dropdown">
   <button className="dropdown-trigger" type="button">Services</button>
   <ul className="dropdown-content">
    <li><Link to="/erp" onClick={onNavigate}>ERP</Link></li>
    <li><Link to="/webdev" onClick={onNavigate}>Web Dev</Link></li>
    <li><Link to="/training" onClick={onNavigate}>Training</Link></li>
   </ul>
  </li>
 )
}
